(function () {
  'use strict';

  function initJourney(section) {
    if (!section || section.dataset.trustJourneyReady === 'true') return;
    section.dataset.trustJourneyReady = 'true';

    var fill    = section.querySelector('.trust-journey__track-fill');
    var nodes   = Array.from(section.querySelectorAll('.trust-journey__node'));
    var bodies  = Array.from(section.querySelectorAll('.trust-journey__step-body'));
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced) {
      if (fill) fill.classList.add('is-animated');
      nodes.forEach(function (n) { n.classList.add('is-reached'); });
      bodies.forEach(function (b) { b.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();

      if (fill) fill.classList.add('is-animated');

      var total = nodes.length;
      nodes.forEach(function (node, i) {
        var delay = total > 1 ? (i / (total - 1)) * 1000 : 0;
        setTimeout(function () { node.classList.add('is-reached'); }, delay);
      });

      bodies.forEach(function (body, i) {
        setTimeout(function () { body.classList.add('is-visible'); }, 200 + i * 120);
      });
    }, { threshold: 0.25 });

    observer.observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-trust-journey]').forEach(initJourney);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = document.querySelector('[data-trust-journey="' + e.detail.sectionId + '"]');
    if (el) { el.removeAttribute('data-trust-journey-ready'); initJourney(el); }
  });
})();
